@if (tenantBrandingService.isWorkspaceNotFound()) {
  <div class="flex items-center justify-center p-4 sm:p-8 w-full min-h-screen workspace-not-found-container">
    <div class="card pb-6 pt-8 sm:pt-10 px-6 sm:px-10 max-w-[440px] w-full">
      <div class="flex justify-center mb-3">
        <div class="h-[48px] max-w-[220px] flex items-center justify-center">
          <img src="assets/creatives/logo-w70.png" class="max-h-full max-w-full w-auto h-auto object-contain" alt="SkillzTank logo" />
        </div>
      </div>

      <div class="flex justify-center mb-5">
        <div class="flex items-center justify-center w-[56px] h-[56px] rounded-full bg-[#f1f5f9]">
          <mat-icon class="text-[26px]! w-[26px]! h-[26px]! text-[#64748b]">domain_disabled</mat-icon>
        </div>
      </div>

      <p class="text-xl font-bold text-[#1D2433] mb-2 text-center">
        {{ 'WorkspaceNotFound.Title' | translate }}
      </p>
      <p class="text-sm text-[#5B6372] mb-6 text-center">
        {{ 'WorkspaceNotFound.Description' | translate }}
      </p>

      <a [href]="createWorkspaceUrl" mat-flat-button btnType="action" class="w-full mb-3">
        {{ 'WorkspaceNotFound.CreateWorkspace' | translate }}
      </a>

      <a href="https://skillztank.com" mat-flat-button btnType="neutral" class="w-full">
        {{ 'WorkspaceNotFound.GoHome' | translate }}
      </a>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
